export enum DaysOfWeekSelection {
  AllDays = 'AllDays',
  Selected = 'Selected',
}
